export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/speechwriting.f0aeae8.svg";